import { STATUS_CODE } from '@kc-console/core';

import { getCurrentLanguage } from '../../utils/getCurrentLanguage';
import { getRequestUrlData } from '../../utils/getRequestUrlData';
import { parsePathname } from '../../utils/parsePathname';
import { syncI18nResources } from '../../utils/syncI18nResources';

import type { BaseState, ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../types';

/**
 * i18n 리소스 동기화를 처리하는 통합 가드 함수
 * @description
 * - 사용자 언어를 결정한 뒤, 매 SSR 요청마다 translation API에서 최신 번역을 가져옵니다
 * - translation-api가 배포 시점에 Redis 캐시를 무효화하므로 다국어 배포 즉시 반영됩니다
 */
export const determineI18nResourceGuard: Guard<ServiceAppState & BaseState> = async ({
  context,
  state,
  queryClient,
}) => {
  try {
    const { serviceKeyword } = state;
    const { urlObj } = getRequestUrlData(context);
    const { serviceKeyword: serviceKeywordByPath } = parsePathname(urlObj.pathname);
    const namespace = serviceKeyword || serviceKeywordByPath;

    const { language } = await getCurrentLanguage({ queryClient, state, context });

    const ssrConfig = await syncI18nResources({
      context,
      namespace,
      queryClient,
      languages: [language],
      locale: language,
      guard: determineI18nResourceGuard.displayName,
    });

    return { ssrConfig, status: STATUS_CODE.OK };
  } catch (error) {
    // i18n 호출 실패 시 콘솔이 정상적으로 동작하지 않는 것으로 간주하여 상태값과 무관하게 500처리
    return { status: STATUS_CODE.INTERNAL_SERVER_ERROR };
  }
};

determineI18nResourceGuard.displayName = 'determineI18nResourceGuard';
